<template>
    <ValidationObserver ref="gradeAppealForm">
        <b-container class="mt-5">
            <b-row>
                <b-col>
                    <b-card class="p-5">
                        <b-row>
                            <b-col cols="12" class="d-flex align-items-center justify-content-between mb-3">
                                <img src="../../../assets/img/BAU_Logo.png" height="75" alt="BAU Logo" />
                            </b-col>
                            <b-col>
                                <h4 class="title-font">{{ $t('formal_grade_appeal_form').toUpperCase() }}</h4>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <p v-html="$t('formal_grade_appeal_description')"></p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <h5 class="section-header">{{ $t('student_information').toUpperCase() }}</h5>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="name" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('student_name')">
                                        <b-form-input v-model="form.name">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="student_id" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('student_id')">
                                        <b-form-input v-model="form.student_id">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="3">
                                <ValidationProvider name="semester" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('semester')">
                                        <semesters-selectbox v-model="form.semester_id"
                                                             :validate-error="errors[0]"></semesters-selectbox>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="3">
                                <ValidationProvider name="academic_year" rules="" v-slot="{valid, errors}">
                                    <b-form-group :label="$t('academic_year')">
                                        <academic-years-selectbox
                                            v-model="form.academic_year"
                                            :validate-error="errors[0]"
                                        >

                                        </academic-years-selectbox>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="3">
                                <ValidationProvider name="course_code" rules="required" v-slot="{errors}">
                                    <b-form-group :label="$t('course_code')">
                                        <course-auto-complete v-model="form.course_code"
                                                              resultType="code"
                                                              :validateError="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="3">
                                <ValidationProvider name="section" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('section')">
                                        <b-form-input type="number" min="1" v-model="form.section"
                                                      :class="errors[0] ? 'is-invalid' : ''"
                                                      :state="errors[0] ? false : null">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]"
                                                                 v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12">
                                <ValidationProvider name="course_instructor" rules="" v-slot="{valid, errors}">
                                    <b-form-group :label="$t('course_instructor')">
                                        <staff-auto-complete v-model="form.course_instructor"
                                                             :validate-error="errors[0]"

                                        />
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <h5 class="section-header">{{ $t('appeal_information').toUpperCase() }}</h5>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="grade_change_date_submitted" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('date_submitted')">
                                        <select-date
                                            v-model="form.grade_change_date_submitted"
                                            :validation-error="errors[0]"
                                        />
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="grade_change_date_decision" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('date_decision')">
                                        <select-date
                                            v-model="form.grade_change_date_decision"
                                            :validation-error="errors[0]"
                                        />
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="appeal_date_submitted" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('date_submitted')">
                                        <select-date
                                            v-model="form.appeal_date_submitted"
                                            :validation-error="errors[0]"
                                        />
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="appeal_date_decision" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('date_decision')">
                                        <select-date
                                            v-model="form.appeal_date_decision"
                                            :validation-error="errors[0]"
                                        />
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <h5 class="section-header">{{ $t('academic_appeals_committee_hearing').toUpperCase() }}</h5>
                            </b-col>
                            <b-col cols="12" md="4">
                                <ValidationProvider name="hearing_date" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('date')">
                                        <select-date
                                            v-model="form.hearing_date"
                                            :validation-error="errors[0]"
                                        />
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="4">
                                <ValidationProvider name="hearing_time" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('time')">
                                        <b-form-input type="time" v-model="form.hearing_time"
                                                      :class="errors[0] ? 'is-invalid' : ''"
                                                      :state="errors[0] ? false : null">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]"
                                                                 v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="4">
                                <ValidationProvider name="location" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('location')">
                                        <b-form-input v-model="form.location">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12">
                                <ValidationProvider name="notification_date" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('notification_date')">
                                        <select-date
                                            v-model="form.notification_date"
                                            :validation-error="errors[0]"
                                        />
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="chief_academic_officer_signature" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('chief_academic_officer_signature')">
                                        <b-form-input v-model="form.chief_academic_officer_signature">
                                        </b-form-input>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6">
                                <ValidationProvider name="signature_date" rules="" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('date')">
                                        <select-date
                                            v-model="form.date"
                                            :validation-error="errors[0]"
                                        />
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </ValidationObserver>
</template>

<script>
import SelectDate from "@/components/interactive-fields/SelectDate.vue";
import SemestersSelectbox from '@/components/interactive-fields/SemestersSelectbox'
import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox.vue";
import CourseAutoComplete from "@/components/interactive-fields/CourseAutoComplete";

export default {
    components: {
        AcademicYearsSelectbox,
        SelectDate,
        SemestersSelectbox,
        CourseAutoComplete,
    },
    data() {
        return {
            form: {
                name: null,
                student_id: null,
                semester_id: null,
                year: null,
                course_code: null,
                section: null,
                course_instructor: null,
                grade_change_date_submitted: null,
                grade_change_date_decision: null,
                appeal_date_submitted: null,
                appeal_date_decision: null,
                hearing_date: null,
                hearing_time: null,
                hearing_location: null,
                notification_date: null,
                chief_academic_officer_signature: null,
                signature_date: null,
                academic_year: null,
            },
        };
    },
    metaInfo() {
        return {
            title: this.$t("formal_grade_appeal_form"),
        };
    },
    methods: {},
};
</script>

<style scoped>
.title-font {
    font-weight: 700;
    color: #e6f0fa;
    background-color: #1a3c6d;
    padding: 10px 20px;
    border-radius: 5px;
    text-transform: uppercase;
    margin-bottom: 20px;
}
.section-header {
    font-weight: 600;
    color: #1a3c6d;
    padding: 8px 0;
    border-top: 3px solid #000000;
    border-bottom: 3px solid #000000;
    margin: 0 0 15px 0;
    width: 100%;
    display: block;
    text-align: left;
}
</style>
